<template>
    <ui-card-base>
        <div class="page-admin-estates-item-legal-block">
            <h2 class="page-admin-estates-item-legal-block__title"
                v-if="title"
                v-text="title"
            />
            <slot />
        </div>
    </ui-card-base>
</template>

<script>
export default {
    name: 'page-admin-estates-item-legal-block',
    props: {
        title: {
            type: String,
            default: null,
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-admin-estates-item-legal-block {
    padding: 8px;
    &__title {
        .typography-medium();

        margin: 0 0 24px;
    }
    @media @media-md-down {
        padding: 0;
    }
}
</style>
